import React from 'react'
import _ from 'lodash'
import ListingBadge, { BADGE_MODE } from './base'
import { getBrokerAgent, isREO, isPrivateSeller } from './utils'

export default class AgentInformationBadge extends ListingBadge {
  static title = 'Contact Agent Info'

  static titleIcon = 'user-tie'

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed. Shown for REO and for
    // private seller (SmartSale) listings that have a listing agent.
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      _.isPlainObject(getBrokerAgent(listing)) &&
      (isREO(listing) || isPrivateSeller(listing))
    )
  }

  get content() {
    return (
      <>
        <a onClick={e => this.emitEvent('contact_agent', e)}>Get in touch</a>{' '}
        with the listing agent for this property
      </>
    )
  }
}
